import { render, staticRenderFns } from "./HeroSmall.vue?vue&type=template&id=698786f6&scoped=true"
import script from "./HeroSmall.vue?vue&type=script&lang=js"
export * from "./HeroSmall.vue?vue&type=script&lang=js"
import style0 from "./HeroSmall.vue?vue&type=style&index=0&id=698786f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698786f6",
  null
  
)

export default component.exports